import { render, staticRenderFns } from "./crudOrdersReasonCustomers.vue?vue&type=template&id=64356490"
import script from "./crudOrdersReasonCustomers.vue?vue&type=script&lang=js"
export * from "./crudOrdersReasonCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports